const state = () => ({
  DataFrom5: {
    tes_id: "",

    stu_homid_f: "",
    stu_soi_f: "",
    stu_road_f: "",
    stu_province_f: "",
    stu_district_f: "",
    stu_local_f: "",
    stu_postcode_f: "",
    stu_phone_f: "",
    stu_fathe_wplace: "",
    stu_fplace_phone: "",

    stu_homid_m: "",
    stu_soi_m: "",
    stu_road_m: "",
    stu_province_m: "",
    stu_district_m: "",
    stu_local_m: "",
    stu_postcode_m: "",
    stu_phone_m: "",
    stu_mother_wplace: "",
    stu_mplace_phone: "",

    select_year: "",
  },
  DataProvince: [],
  DataDistrictF: [],
  DataLocalityF: [],
  DataDistrictM: [],
  DataLocalityM: [],
  SetStep5: [],
  DataStudent_test: [],
});
/* ========== getters ========== */
const getters = {
  _getDataFrom5: (state) => {
    return state.DataFrom5;
  },
  _getDataProvince: (state) => {
    return state.DataProvince;
  },
  _getDataDistrictF: (state) => {
    return state.DataDistrictF;
  },
  _getDataLocalityF: (state) => {
    return state.DataLocalityF;
  },
  _getDataDistrictM: (state) => {
    return state.DataDistrictM;
  },
  _getDataLocalityM: (state) => {
    return state.DataLocalityM;
  },
  _SetStep5: (state) => {
    return state.SetStep5;
  },
  _getDataStudent_test: (state) => {
    return state.DataStudent_test;
  },
};
/* ========== actions ========== */
const actions = {
  async SetStepStatus({ state, rootState }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      // console.log(state.DataFrom5);
      const response = await window.Axios.post(
        `${window.api}exec/GetStepStatus5/`,
        state.DataFrom5
      );
      rootState.Main.DataStep5 = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async SetStep5({ state }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      let data = {
        tes_id: state.DataFrom5.tes_id,
      };
      // console.log(state.DataFrom5);
      const response = await window.Axios.post(
        `${window.api}post/GetStep5/`,
        data
      );
      state.SetStep5 = response.data;

      const statStep5 = state.SetStep5;
      const From5 = state.DataFrom5;

      if (state.SetStep5 != "") {
        statStep5.stu_homid_f
          ? (From5.stu_homid_f = statStep5.stu_homid_f.trim())
          : "";
        statStep5.stu_soi_f
          ? (From5.stu_soi_f = statStep5.stu_soi_f.trim())
          : "";
        statStep5.stu_road_f
          ? (From5.stu_road_f = statStep5.stu_road_f.trim())
          : "";
        statStep5.stu_province_f
          ? (From5.stu_province_f = statStep5.stu_province_f.trim())
          : "";
        statStep5.stu_district_f
          ? (From5.stu_district_f = statStep5.stu_district_f.trim())
          : "";
        statStep5.stu_local_f
          ? (From5.stu_local_f = statStep5.stu_local_f.trim())
          : "";
        statStep5.stu_postcode_f
          ? (From5.stu_postcode_f = statStep5.stu_postcode_f.trim())
          : "";
        statStep5.stu_phone_f
          ? (From5.stu_phone_f = statStep5.stu_phone_f.trim())
          : "";
        statStep5.stu_fathe_wplace
          ? (From5.stu_fathe_wplace = statStep5.stu_fathe_wplace.trim())
          : "";
        statStep5.stu_fplace_phone
          ? (From5.stu_fplace_phone = statStep5.stu_fplace_phone.trim())
          : "";

        statStep5.stu_homid_m
          ? (From5.stu_homid_m = statStep5.stu_homid_m.trim())
          : "";
        statStep5.stu_soi_m
          ? (From5.stu_soi_m = statStep5.stu_soi_m.trim())
          : "";
        statStep5.stu_road_m
          ? (From5.stu_road_m = statStep5.stu_road_m.trim())
          : "";
        statStep5.stu_province_m
          ? (From5.stu_province_m = statStep5.stu_province_m.trim())
          : "";
        statStep5.stu_district_m
          ? (From5.stu_district_m = statStep5.stu_district_m.trim())
          : "";
        statStep5.stu_local_m
          ? (From5.stu_local_m = statStep5.stu_local_m.trim())
          : "";
        statStep5.stu_postcode_m
          ? (From5.stu_postcode_m = statStep5.stu_postcode_m.trim())
          : "";
        statStep5.stu_phone_m
          ? (From5.stu_phone_m = statStep5.stu_phone_m.trim())
          : "";
        statStep5.stu_mother_wplace
          ? (From5.stu_mother_wplace = statStep5.stu_mother_wplace.trim())
          : "";
        statStep5.stu_mplace_phone
          ? (From5.stu_mplace_phone = statStep5.stu_mplace_phone.trim())
          : "";
      }
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataProvince({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetProvince/`);
      await commit("GET_DataProvince", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDistrictF({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetDistrictF/`,
        state.DataFrom5
      );
      await commit("POST_DataDistrictF", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataLocalityF({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetLocalityF/`,
        state.DataFrom5
      );
      await commit("POST_DataLocalityF", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDistrictM({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetDistrictM/`,
        state.DataFrom5
      );
      await commit("POST_DataDistrictM", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataLocalityM({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetLocalityM/`,
        state.DataFrom5
      );
      await commit("POST_DataLocalityM", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_Student_Test({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetStudent_Test/`,
        state.DataFrom5
      );
      await commit("POST_Student_Test", response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  GET_DataProvince(state, payload) {
    state.DataProvince = payload;
  },
  POST_DataDistrictF(state, payload) {
    state.DataDistrictF = payload;
  },
  POST_DataLocalityF(state, payload) {
    state.DataLocalityF = payload;
  },
  POST_DataDistrictM(state, payload) {
    state.DataDistrictM = payload;
  },
  POST_DataLocalityM(state, payload) {
    state.DataLocalityM = payload;
  },
  POST_Student_Test(state, payload) {
    state.DataStudent_test = payload;
  },
};

/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
